document.addEventListener("DOMContentLoaded", function () {
  const cartElements = {
    countBadge: document.getElementById("cart-count"),
    countText: document.querySelector(".mc-topbar__cart-count-text"),
    cartLink: document.querySelector(".mc-topbar__cart-link"),
    cartDrawer: document.querySelector("cart-drawer"),
  };

  function updateCartCount(count) {
    if (cartElements.countBadge) cartElements.countBadge.textContent = count;
    if (cartElements.countText) cartElements.countText.textContent = count;
  }

  function openCartDrawer(e) {
    if (e) e.preventDefault();
    if (
      cartElements.cartDrawer &&
      typeof cartElements.cartDrawer.open === "function"
    ) {
      cartElements.cartDrawer.classList.add("is-active");
      cartElements.cartDrawer.open();
    }
  }

  async function fetchCartCount() {
    try {
      const response = await fetch("/cart.js");
      if (response.ok) {
        const cart = await response.json();
        updateCartCount(cart.item_count);
      }
    } catch (error) {
      console.error("Cart fetch failed:", error);
    }
  }

  // Intercept cart requests
  const originalFetch = window.fetch;
  window.fetch = function (...args) {
    const url = args[0];
    const isCartRequest =
      typeof url === "string" && /\/cart\/(add|update|change)/.test(url);

    if (isCartRequest) {
      return originalFetch.apply(this, args).then((response) => {
        setTimeout(() => {
          fetchCartCount();
          if (url.includes("/cart/add")) openCartDrawer();
        }, 300);
        return response;
      });
    }

    return originalFetch.apply(this, args);
  };

  if (cartElements.cartLink) {
    cartElements.cartLink.addEventListener("click", openCartDrawer);
  }

  fetchCartCount();
});
